/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_DoneInputs */

const en_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const fr_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

const de_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigt`)
};

const it_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

const ru_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделанный`)
};

const es_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho`)
};

const zh_cn2_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完毕`)
};

const ja_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終わり`)
};

const hi_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हो गया`)
};

const pt_pt2_iconik_import_status_done = /** @type {(inputs: Iconik_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Iconik_Import_Status_DoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_done = /** @type {((inputs?: Iconik_Import_Status_DoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_DoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_status_done(inputs)
	if (locale === "de") return de_iconik_import_status_done(inputs)
	if (locale === "it") return it_iconik_import_status_done(inputs)
	if (locale === "ru") return ru_iconik_import_status_done(inputs)
	if (locale === "es") return es_iconik_import_status_done(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_status_done(inputs)
	if (locale === "ja") return ja_iconik_import_status_done(inputs)
	if (locale === "hi") return hi_iconik_import_status_done(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_status_done(inputs)
	return en_iconik_import_status_done(inputs)
});